/* Sève first-party attribution.
   Captures UTM/click-id/referrer on landing, keeps first touch (write once)
   + last touch (overwritten on each attributed landing) in localStorage,
   writes both onto the Shopify cart as underscore-prefixed attributes so
   every order carries its own attribution independent of Shopify's journey
   system, and stamps newsletter signups (form_type=customer) with source tags.
   No third-party calls; everything stays first-party. */
(function () {
  'use strict';
  var LS_FIRST = 'sh_attr_first';
  var LS_LAST = 'sh_attr_last';
  var LS_SYNC = 'sh_attr_sync';
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid', 'msclkid', 'twclid', 'dclid', 'yclid', 'li_fat_id', 'epik', 'irclickid', 'sccid', 'wbraid', 'gbraid', 'utm_id', 'mc_cid'];

  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ---- capture on landing ---- */
  function capture(deriveOnly) {
    var q, sig = {}, hasParam = false;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    for (var i = 0; i < PARAMS.length; i++) {
      var v = q.get(PARAMS[i]);
      if (v) { sig[PARAMS[i]] = String(v).slice(0, 180); hasParam = true; }
    }
    var ref = document.referrer || '';
    var refHost = '';
    try { refHost = ref ? new URL(ref).hostname.replace(/^www\./, '') : ''; } catch (e) {}
    var external = !!refHost && refHost !== location.hostname.replace(/^www\./, '');
    if (!hasParam && !external) return; /* internal navigation or clean direct: not a touch */

    var source = sig.utm_source ||
      (/instagram/.test(refHost) ? 'instagram'
        : /facebook|fb\.com/.test(refHost) ? 'facebook'
        : /google/.test(refHost) ? 'google'
        : /tiktok/.test(refHost) ? 'tiktok'
        : external ? refHost
        : sig.fbclid ? 'facebook' : sig.gclid ? 'google' : sig.ttclid ? 'tiktok' : 'direct');
    var medium = sig.utm_medium ||
      (sig.gclid ? 'cpc' : sig.fbclid || sig.ttclid ? 'social-click' : external ? 'referral' : 'unknown');

    var touch = {
      source: source, medium: medium, campaign: sig.utm_campaign || '',
      content: sig.utm_content || '', term: sig.utm_term || '',
      fbclid: sig.fbclid || '', gclid: sig.gclid || '', ttclid: sig.ttclid || '',
      referrer: ref.slice(0, 200),
      landing: (location.pathname + location.search).slice(0, 400),
      at: new Date().toISOString()
    };
    if (deriveOnly) return touch;
    if (!lsGet(LS_FIRST)) lsSet(LS_FIRST, touch); /* first touch: write once, never overwrite */
    lsSet(LS_LAST, touch);                        /* last touch: every attributed landing wins */
  }

  /* ---- cart attribute sync ---- */
  function cartToken() { return (document.cookie.match(/(?:^|;\s*)cart=([^;]+)/) || [])[1] || ''; }

    // attribution source of truth: local store when it works, else re-derive from the URL
    // (webviews that block or partition storage still carry the ad tags in the address bar)
    function touches() { var f = lsGet(LS_FIRST), l = lsGet(LS_LAST); if (f || l) return { f: f || l, l: l || f, state: 'ls' }; var u = capture(true); if (u) return { f: u, l: u, state: 'url' }; return { f: {}, l: {}, state: 'none' }; }
  var syncBusy = false;
  function syncCart() {
    if (syncBusy) return Promise.resolve();
    var t = touches(), f = t.f, l = t.l;
    var tok = cartToken();
    if (!tok) return Promise.resolve(); /* no cart yet; nothing to attach to */
    var attrs = {
      _first_source: f.source, _first_medium: f.medium, _first_campaign: f.campaign,
      _first_landing: f.landing, _first_at: f.at,
      _last_source: l.source, _last_medium: l.medium, _last_campaign: l.campaign,
      _last_landing: l.landing, _last_at: l.at, attr_state: t.state
    };
    var state = tok + '|' + JSON.stringify(attrs);
    var done = lsGet(LS_SYNC);
    if (done === state) return Promise.resolve(); /* this cart already carries these exact values */
    syncBusy = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (r.ok) lsSet(LS_SYNC, state);
    }).catch(function () {}).then(function () { syncBusy = false; });
  }
  /* exposed so flows that navigate right after add-to-cart (paid LP buy-now ->
     /checkout) can await the attribute write instead of racing it */
  window.shAttribSync = syncCart;

  /* catch every add-to-cart path (PDP, drawer, home cards, fuel guide all use fetch) */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = '';
    try { url = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0]); } catch (e) {}
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?/.test(url)) {
      p.then(function (r) { if (r && r.ok) setTimeout(syncCart, 400); }).catch(function () {});
    }
    return p;
  };

  /* ---- newsletter signup tagging (popup + footer, both form_type=customer) ---- */
  function tagSan(v) {
    return String(v || '').toLowerCase().replace(/[^a-z0-9._\/-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var ft = form.querySelector('input[name="form_type"]');
    if (!ft || ft.value !== 'customer') return;
    var nt = touches(), f = nt.f, l = nt.l;
    var tags = [];
    function push(prefix, val) { var s = tagSan(val); if (s) tags.push(prefix + s); }
    if (f) { push('attr-fsrc:', f.source); push('attr-fmed:', f.medium); push('attr-fcamp:', f.campaign); }
    if (l) { push('attr-lsrc:', l.source); push('attr-lmed:', l.medium); push('attr-lcamp:', l.campaign); }
    if (!tags.length) return;
    var input = form.querySelector('input[name="contact[tags]"]');
    if (input) {
      var existing = input.value ? input.value.split(',') : [];
      var keep = existing.filter(function (t) { return t.indexOf('attr-') !== 0; });
      input.value = keep.concat(tags).join(',');
    } else {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[tags]';
      input.value = tags.join(',');
      form.appendChild(input);
    }
  }, true); /* capture phase: runs before the form posts */

  capture();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(syncCart, 800); });
  } else {
    setTimeout(syncCart, 800);
  }
})();
